module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/projects.json
// module id = 338
// module chunks = 97786326051841